import { render, staticRenderFns } from "./AmazonMwsSubmissions.vue?vue&type=template&id=6aa21ba0&scoped=true&"
import script from "./AmazonMwsSubmissions.vue?vue&type=script&lang=js&"
export * from "./AmazonMwsSubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa21ba0",
  null
  
)

export default component.exports